import cn from 'classnames';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import SeoData from 'src/common/components/content/Seo/SeoData';
import { BrandListType, ModelListType } from 'src/modules/newCars/types';
import {
  handleSeoData,
  processListingSeoData,
} from 'src/modules/newCars/utils/seoContent';
import { Pagination, Typography } from 'ui';
import { LatestNews } from '../../LatestNews/LatestNews';
import Sort from '../../Sort';
import VehicleCard from '../../cards/VehicleCard';
import { Jumbo } from '../../content/Jumbo/Jumbo';
import DesktopFilter from '../DesktopFilter';
import FilterTab from '../Listing/FilterTab';
import BestCarsList from './BestCarsList';
import { CategoryHero } from './CategoryHero/CategoryHero';
// import BrandAd from '../../BrandAd';
import { WEBSITE_URL } from 'core-lib/data/common';
import VideoReview from '../../VideoReview';
import Faq from '../../content/Faq';
import s from './Listing.module.scss';

export const Listing = ({
  content,
  itemListContent,
  itemListTitle,
  strapiContent,
  brandList,
  filterPayload,
  isPwa = false,
  slug,
}: {
  content: ModelListType;
  itemListContent: ModelListType;
  itemListTitle: any;
  strapiContent: any;
  brandList: BrandListType[];
  filterPayload: any;
  isPwa?: boolean;
  slug: any;
}) => {
  //console.log(' Listing content ', content);
  //  console.log(' Listing strapi content', strapiContent);
  //console.log(' slug ', slug);

  const [pageContent, setPageContent] = useState({
    ...content,
    modelList: content?.modelList.slice(0, 10),
  });
  const noOfPages = content?.noOfModels
    ? Math.ceil(content.noOfModels / 10)
    : 0;
  const router = useRouter();
  const pagePath = router?.asPath;
  const canonicalisedUrl = pagePath.includes('?')
    ? `${WEBSITE_URL}${pagePath?.slice(0, pagePath?.indexOf('?'))}`
    : `${WEBSITE_URL}${pagePath}`;
  const [showSort, setShowSort] = useState(false);
  useEffect(() => {
    // eslint-disable-next-line no-unsafe-optional-chaining
    setPageContent(content);
  }, [router?.query]);

  useEffect(() => {
    if (showSort) {
      document.body.style.overflow = 'hidden';
    } else document.body.style.overflow = 'unset';
  }, [showSort]);
  const serializeCarsData = (carsContent: ModelListType) => {
    const obj = carsContent?.modelList?.map((car) => {
      return {
        name: car?.name,
        startingPrice: car?.minPrice,
        modelSlug: car?.modelSlug,
        brandSlug: slug?.slug?.join(''),
      };
    });
    return obj;
  };
  const listRef = useRef(null);
  const [listHeight, setListHeight] = useState(0);
  useEffect(() => {
    if (listRef.current) {
      setListHeight(listRef.current.clientHeight);
    }
  }, []);
  return (
    <div className={s.root}>
      <SeoData
        data={handleSeoData(
          strapiContent?.carListing,
          pageContent?.seoData,
          pageContent?.name,
          pagePath
        )}
        canonicalisedUrl={canonicalisedUrl}
      />
      <div className={s.header}>
        <CategoryHero
          strapiContent={strapiContent?.carListing}
          label=""
          brandsList={brandList}
          slug={slug.slug}
        />
      </div>
      {strapiContent?.carListing?.jumbo && (
        <section className={s.section}>
          <Jumbo
            jumbo={processListingSeoData(
              strapiContent?.carListing?.jumbo,
              pageContent?.seoData,
              pageContent?.name
            )}
            maxHeight={135} 

          />
        </section>
      )}
      <div className={s.content}>
        <DesktopFilter
          brandList={brandList}
          selectedFilter={''}
          slug={slug?.slug}
        />
        <div className={s.right}>
          <div className={cn('cmn_only_mobile', s.filters)}>
            <FilterTab brandList={brandList} />
          </div>
          <div className={cn(s.tabs_heading, 'cmn_only_desktop')}>
            <Typography
              label={
                pageContent?.noOfModels
                  ? `Total cars available (${pageContent?.noOfModels})`
                  : 'No cars found'
              }
              className={s.heading}
            />
            <Sort />
          </div>
          <div className={s.listing}>
            {pageContent?.modelList?.map((obj) => (
              <VehicleCard
                model={obj}
                brandName={obj?.brandName}
                key={obj.name}
                modelName={obj?.modelName}
                slug={obj?.slug}
              />
            ))}
          </div>
          <div className={s.pagination}>
            <Pagination
              activePage={+router.query.page || 1}
              totalPages={noOfPages}
              onNextClick={() => {
                router.replace({
                  query: {
                    ...router.query,
                    page: (+router.query.page || 1) + 1,
                  },
                });
              }}
              onPrevClick={() => {
                router.replace({
                  query: {
                    ...router.query,
                    page: +router.query.page - 1,
                  },
                });
              }}
              theme="default"
            />
          </div>
        </div>
      </div>
      {strapiContent?.news?.length && (
        <LatestNews data={strapiContent?.news} heading={`Latest news`} />
      )}
      {strapiContent?.videoReview && (
        <VideoReview data={strapiContent.videoReview} />
      )}
      {strapiContent?.carListing?.mustRead && (
        <section className={s.section}>
          <Jumbo
            jumbo={processListingSeoData(
              strapiContent?.carListing?.mustRead,
              pageContent?.seoData,
              pageContent?.name
            )}
          />
        </section>
      )}
      {/* {strapiContent?.carListing?.mustRead && (
        <ScrollableJumbo
          heading="Must read article"
          description={strapiContent?.carListing?.mustRead}
        />
      )} */}
      {/* <BrandAd /> */}
      <div className={s.infoBox}>
        {strapiContent?.carListing?.faqTitle &&
          strapiContent?.carListing?.faqContent && (
            <Faq
              faqTitle={strapiContent?.carListing?.faqTitle}
              faqContent={processListingSeoData(
                strapiContent?.carListing?.faqContent,
                content?.seoData,
                content?.name
              )}
              viewHeight={listHeight}
            />
          )}
        <BestCarsList
          heading={itemListTitle}
          componentRef={listRef}
          bestCars={serializeCarsData(itemListContent)}
        />
      </div>
    </div>
  );
};
